import { render } from "./CardDetail.vue?vue&type=template&id=3b7ca458&scoped=true"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"

import "./CardDetail.vue?vue&type=style&index=0&id=3b7ca458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7ca458"]])

export default __exports__